import { BallTriangle } from 'react-loader-spinner';

const Loader = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <BallTriangle
                width="60"
                color="#2C81FF"
            />
        </div>

    );
};

export default Loader;